import type { TElement } from '@udecode/plate';
import { useEffect, useState } from 'react';

import { useApi } from '../../api/useApi.hook';

export type RevisionContentMap = Record<string, TElement>;

export function useRevisionContent(documentId: string, revisionId: string | null): RevisionContentMap | null {
    const api = useApi();
    const [contentMap, setContentMap] = useState<RevisionContentMap | null>(null);

    useEffect(() => {
        if (!revisionId) return;

        let cancelled = false;

        api.v1.documents.getRevisionById(documentId, revisionId).then((revision) => {
            if (cancelled) return;

            const raw = revision.content as { contents?: Record<string, { children: unknown[] }> } | null;
            if (!raw?.contents) {
                setContentMap({});
                return;
            }

            const map: RevisionContentMap = {};
            for (const [id, slateContent] of Object.entries(raw.contents)) {
                if (slateContent?.children) {
                    map[id] = slateContent as unknown as TElement;
                }
            }

            setContentMap(map);
        }).catch(() => {
            setContentMap({});
        });

        return () => { cancelled = true; };
    }, [documentId, revisionId]);

    return contentMap;
}
